export default __webpack_public_path__ + "static/media/AddDisabled.e5103a60.svg";